import lscache from "lscache";

import {OFFER_OPINIONS_SENT_LS_KEY} from "../../app/constants/storage_keys";

export const offerOpinionLS = {
    getIsOpinionSent: function (offerId: number) {
        const sentOpinions = lscache.get(OFFER_OPINIONS_SENT_LS_KEY);
        return !!sentOpinions && Array.isArray(sentOpinions) && sentOpinions.includes(offerId);
    },
    addSentOfferId: function (offerId: number, retry = 1) {
        const isOpinionSent = this.getIsOpinionSent(offerId);
        if (isOpinionSent) {
            return;
        }

        const sentOpinions = lscache.get(OFFER_OPINIONS_SENT_LS_KEY);

        if (!sentOpinions) {
            lscache.set(OFFER_OPINIONS_SENT_LS_KEY, [offerId]);
            return;
        }

        if (sentOpinions && Array.isArray(sentOpinions)) {
            lscache.set(OFFER_OPINIONS_SENT_LS_KEY, sentOpinions.concat(offerId));
            return;
        }

        if (retry) {
            // lscache entry is corrupt, stores incorrect format, etc. Remove entry and retry
            lscache.remove(OFFER_OPINIONS_SENT_LS_KEY);
            setTimeout(() => {
                this.addSentOfferId(offerId, retry--);
            }, 500);
        }
    }
};
import lscache from "lscache";

import {OFFER_OPINIONS_SENT_LS_KEY} from "../../app/constants/storage_keys";

export const offerOpinionLS = {
    getIsOpinionSent: function (offerId: number) {
        const sentOpinions = lscache.get(OFFER_OPINIONS_SENT_LS_KEY);
        return !!sentOpinions && Array.isArray(sentOpinions) && sentOpinions.includes(offerId);
    },
    addSentOfferId: function (offerId: number, retry = 1) {
        const isOpinionSent = this.getIsOpinionSent(offerId);
        if (isOpinionSent) {
            return;
        }

        const sentOpinions = lscache.get(OFFER_OPINIONS_SENT_LS_KEY);

        if (!sentOpinions) {
            lscache.set(OFFER_OPINIONS_SENT_LS_KEY, [offerId]);
            return;
        }

        if (sentOpinions && Array.isArray(sentOpinions)) {
            lscache.set(OFFER_OPINIONS_SENT_LS_KEY, sentOpinions.concat(offerId));
            return;
        }

        if (retry) {
            // lscache entry is corrupt, stores incorrect format, etc. Remove entry and retry
            lscache.remove(OFFER_OPINIONS_SENT_LS_KEY);
            setTimeout(() => {
                this.addSentOfferId(offerId, retry--);
            }, 500);
        }
    }
};
